import http from "@/settings/apiSettings"

class CrmSalesSourcesDataService{
  save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_SalesSources", data);
      }
}

export default new CrmSalesSourcesDataService();